import { useAuthStore } from '../store/useAuthStore';

// Bild-URL für eine hochgeladene Datei. Der Zugriff wird über das httpOnly-
// Medien-Cookie authentifiziert (vom Browser automatisch mitgeschickt) – daher
// steckt KEIN Token in der URL. Das `accessToken` dient nur als „eingeloggt?"-
// Signal, damit nicht schon vor dem Login Bilder angefragt werden.
export function useUploadUrl(filename: string | null | undefined): string | undefined {
  const accessToken = useAuthStore((s) => s.accessToken);
  if (!filename || !accessToken) return undefined;
  return `/uploads/${filename}`;
}
